import type { AdminUserIdentity, UserPlatform } from "@/api/admin/users";

/** i18n key for a platform label — `t(PLATFORM_KEY[row.platform])`. */
export const PLATFORM_KEY: Record<UserPlatform, `users.platform.${UserPlatform}`> = {
  telegram: "users.platform.telegram",
  ios_guest: "users.platform.ios_guest",
  apple: "users.platform.apple",
  apple_ex_guest: "users.platform.apple_ex_guest",
  web: "users.platform.web",
};

/** Short, copy-pasteable prefix of a device UUID. */
function shortDevice(deviceId: string): string {
  return deviceId.slice(0, 8);
}

/**
 * Human label for an account, or null when nothing identifies it — the
 * caller renders `t("users.no_name")` in that case. iOS guests carry no
 * first/last name (those are filled from Telegram initData only), so the
 * device-id prefix is the last resort before the numeric id.
 */
export function displayName(row: AdminUserIdentity): string | null {
  const full = [row.first_name, row.last_name].filter(Boolean).join(" ").trim();
  if (full) return full;
  if (row.username) return `@${row.username}`;
  if (row.device_id) return shortDevice(row.device_id);
  return null;
}

/** The identifier column: tg_id, else short device id, else `#users.id`. */
export function identLabel(row: AdminUserIdentity): string {
  if (row.tg_id !== null) return String(row.tg_id);
  if (row.device_id) return shortDevice(row.device_id);
  return `#${row.id}`;
}
